<template>
  <BasePage title="Forgot Password">
    <AuthContainer>
        <section class="box mt-4">
          <h1 class="title is-2">Reset Password</h1>

          <form @submit.prevent="reset()">

            <div class="field">
              <label class="label">Email</label>
              <p class="control">
                <input
                  v-focus
                  v-model="email"
                  :class="invalid && 'is-danger'"
                  class="input"
                  type="email"
                  placeholder="name@example.com"
                  />
                <p v-if="invalid" class="help is-danger">This email is invalid</p>
              </p>
            </div>

            <section class="d-flex justify-content-between flex-align-center">
              <button type="submit"
                      class="button is-primary"
                      :class="loading && 'is-loading'"
                      :disabled="!valid">
                      Reset
              </button>
              <router-link to="/login">Login →</router-link>
            </section>

          </form>
        </section>
    </AuthContainer>
  </BasePage>
</template>

<script>
import AuthContainer from './AuthContainer'
import BasePage from './BasePage'

import { focus } from '../directives'

import store from '../store'
import { passwordReset } from '../actionTypes'

export default {
  name: 'PasswordReset',
  data () {
    return {
      email: '',
      invalid: false,
      loading: false,
    }
  },
  components: {
    BasePage,
    AuthContainer,
  },
  computed: {
    valid () {
      return this.email !== ''
    },
  },
  methods: {
    async reset () {
      const { email } = this
      this.loading = true
      try {
        await store.dispatch(passwordReset, { email })
        this.invalid = false
        this.email = ''
      } catch (err) {
        this.invalid = true
      }
      this.loading = false
    },
  },
  directives: {
    focus,
  },
}
</script>



// WEBPACK FOOTER //
// ForgotPassword.vue?7dcec40c